<div class="login-background">
    <div class="login-block">
        <div id="errorMessage">
            @if (validToken == ValidationState.Validating) {
                De wachtwoordvalidatie token wordt gevalideerd.
            }
            @if (validToken == ValidationState.Invalid) {
                <p>Deze link is niet meer geldig.</p>
                <a class="textlink next" routerLink="/wachtwoord-vergeten">Vraag hier een nieuwe link aan</a>
            }
            @if (message) {
                {{ message }}
            }
        </div>

        @if (validToken == ValidationState.Valid) {
            <div>
                <form [formGroup]="form">
                    <div class="title">
                        <h1 class="h4 condensed">Nieuw wachtwoord</h1>
                    </div>
                    <mat-form-field id="password" appearance="fill">
                        <mat-label>Wachtwoord</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="password"
                            name="password"
                            autocomplete="new-password"
                            placeholder="Je nieuwe wachtwoord" />
                        <mat-error [control]="form.get('password')"></mat-error>
                    </mat-form-field>
                    <mat-form-field id="passwordconf" appearance="fill">
                        <mat-label>Wachtwoord (herhaling)</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="passwordconf"
                            name="passwordconf"
                            autocomplete="new-password"
                            placeholder="Je wachtwoord ter bevestiging" />
                        <mat-error [control]="form.get('passwordconf')"></mat-error>
                    </mat-form-field>
                    <div class="login-buttons">
                        <button
                            id="btn-setpassword"
                            [disabled]="form.invalid"
                            (click)="setNewPassword()"
                            mat-raised-button
                            color="primary">
                            {{ loading ? 'We stellen je nieuwe wachtwoord in...' : 'Wachtwoord instellen' }}
                        </button>
                    </div>
                </form>
            </div>
        }
    </div>
</div>
